import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Event, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createVideoConferenceCall(
    request: Boundaries["createVideoConferenceCall"]["request"],
  ): void;
}

function useCreateVideoConferenceCall(event: Identifiable<Event>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isCreateVideoConferenceCallRequestPending(event),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isCreateVideoConferenceCallRequestSuccess(event),
    ),
    isRequestFailure: useSelector(() =>
      selector.isCreateVideoConferenceCallRequestFailure(event),
    ),
    createVideoConferenceCall: core.createVideoConferenceCall,
  };
}

export { useCreateVideoConferenceCall };
